import Vue from "vue";
//模块功能：港口信息与气象
export default Vue.extend({
    name: "port-info-meteo",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.portmeteo');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/port-info-meteo.vue
// module id = null
// module chunks = 